module.exports = __webpack_public_path__ + "img/pr-4.cf3808fa.png";